import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Save, Mail, AlertTriangle } from "lucide-react";
import { inputCls } from "./shared";

const EmailTemplatesTab = ({ tpl, setTpl, tplKind, changeTplKind, saveTemplate, testEmail, setTestEmail, sendTestEmail }) => (
  <div className="bg-white border border-[var(--ir-border)] rounded-lg soft-shadow p-8 max-w-3xl">
    {!tpl.email_configured && (
      <div className="flex items-start gap-3 bg-[var(--ir-orange)]/10 border border-[var(--ir-orange)]/30 rounded-md p-4 mb-6" data-testid="email-not-configured-banner">
        <AlertTriangle className="w-5 h-5 text-[var(--ir-orange)] mt-0.5" />
        <div className="text-sm text-[var(--ir-text)]">Email sending is not active. Add your Resend API key to enable sending.</div>
      </div>
    )}
    <div className="flex flex-wrap items-center justify-between gap-4">
      <h3 className="font-display text-2xl text-[var(--ir-text)]">Email Templates</h3>
      <Select value={tplKind} onValueChange={changeTplKind}>
        <SelectTrigger className={`w-56 ${inputCls}`} data-testid="template-kind-select"><SelectValue /></SelectTrigger>
        <SelectContent className="bg-white border-[var(--ir-border)] text-[var(--ir-text)]">
          <SelectItem value="member">Member welcome email</SelectItem>
          <SelectItem value="affiliate">Affiliate welcome email</SelectItem>
        </SelectContent>
      </Select>
    </div>
    <p className="text-[var(--ir-muted)] text-sm mt-3">
      {tplKind === "affiliate"
        ? <>Sent when a member is enrolled as an affiliate. Placeholders: <code className="text-[var(--ir-blue)]">{"{{name}}"}</code>, <code className="text-[var(--ir-blue)]">{"{{referral_link}}"}</code>, <code className="text-[var(--ir-blue)]">{"{{commission_percent}}"}</code> (auto-filled from your commission rate).</>
        : <>Sent when a member is approved and assigned a code. Placeholders: <code className="text-[var(--ir-blue)]">{"{{name}}"}</code>, <code className="text-[var(--ir-blue)]">{"{{code}}"}</code>.</>}
      {" "}Sending from: <strong>{tpl.sender_email}</strong>
    </p>
    <div className="mt-6 space-y-5">
      <div>
        <Label className="text-[var(--ir-text)]">Subject</Label>
        <Input value={tpl.subject} onChange={(e) => setTpl({ ...tpl, subject: e.target.value })} className={`mt-2 ${inputCls}`} data-testid="email-subject-input" />
      </div>
      <div>
        <Label className="text-[var(--ir-text)]">Body (HTML)</Label>
        <Textarea value={tpl.body_html} onChange={(e) => setTpl({ ...tpl, body_html: e.target.value })} rows={14} className={`mt-2 font-mono text-xs ${inputCls}`} data-testid="email-body-input" />
      </div>
      <Button onClick={saveTemplate} className="bg-[var(--ir-orange)] hover:bg-[var(--ir-orange-soft)] text-white font-semibold rounded-none" data-testid="save-template-btn">
        <Save className="w-4 h-4 mr-2" />Save Template
      </Button>
      <div className="border-t border-[var(--ir-border)] pt-5">
        <Label className="text-[var(--ir-text)]">Send a test email to yourself</Label>
        <div className="flex flex-col sm:flex-row gap-3 mt-3">
          <Input type="email" value={testEmail} onChange={(e) => setTestEmail(e.target.value)} placeholder="you@example.com" className={`${inputCls} sm:max-w-xs`} data-testid="test-email-input" />
          <Button onClick={sendTestEmail} disabled={!testEmail} variant="outline" className="border-[var(--ir-blue)]/40 bg-white text-[var(--ir-blue)] hover:bg-[var(--ir-surface2)] rounded-none" data-testid="send-test-email-btn">
            <Mail className="w-4 h-4 mr-2" />Send test email
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default EmailTemplatesTab;
